import React from 'react'

export const Error = () => {
  return <div>Error</div>
}
